
import { validationMixin } from "vuelidate";
import ConfiguracaoData, { ConfiguracaoDataRequired } from "./ConfiguracaoData";
import { onboardStore } from "../../../onboardStore";
import { mapGetters } from "vuex";
const HOMOLOCAGAO = 2;
import { SistemaMixin } from "@/modules/Application";

export default {
  name: "app-configuracao-form",
  props: {
    url: {
      type: String,
    },
    configuracao: {
      type: ConfiguracaoData,
      required: true,
    },
  },
  mixins: [validationMixin, SistemaMixin],
  data() {
    return {
      onboardStore,
      tabIndex: 0,
      form: {},
      ambientes: [
        {
          id: 1,
          descricao: "Produçao",
        },
        {
          id: 2,
          descricao: "Homologacao",
        },
      ],
      modelos: [
        {
          id: 55,
          descricao: "NFe",
        },
        {
          id: 65,
          descricao: "NFCe/Pré-venda",
        },
        {
          id: 58,
          descricao: "MDFe",
        },
      ],
      tiposMDFe: [
        {
          id: 0,
          descricao: "Não Aplicavel",
        },
        {
          id: 1,
          descricao: "ETC - Empresa de Transporte Rodoviário de Cargas",
        },
        {
          id: 2,
          descricao: "TAC - Transportador Autônomo de Cargas",
        },
        {
          id: 3,
          descricao: "CTC - Cooperativa de Transporte rodoviário de Carga",
        },
      ],
      tipo_transportador: null,
    };
  },
  validations: {
    form: ConfiguracaoDataRequired,
  },
  watch: {
    configuracao(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.form = newValue;
      }
    },
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  async mounted() {
    this.$root.$emit("bv::show::popover", "ambienteTuto");
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
    await this.getDataInit();
  },
  methods: {
    async getDataInit() {
      this.form = await new ConfiguracaoData({});
    },
    setDadosCartao() {
      this.form.solicitarDadosCartao =
        this.form.solicitarDadosCartao == true ? false : true;
    },
    setAtivo() {
      this.form.ativo = this.form.ativo == true ? false : true;
    },
    setContigenciaSVCAN() {
      this.form.contigenciaSVCAN =
        this.form.contigenciaSVCAN == true ? false : true;
    },
    setPadraoPdvWeb() {
      if (this.form.padrao_pdv_web == true) {
        this.$toast.info(
          "Para alterar o padrão do PDV Web, marque outra configuração como padrão."
        );
        return;
      }

      this.form.padrao_pdv_web = true;
      this.$toast.info(
        "Esta configuração será usada como padrão no PDV Web. As demais configurações deixarão de ser padrão."
      );
    },
    setModelo() {
      this.form.modelo = this.form.modelo;
    },
    setSerie() {
      if (this.form.ambiente === HOMOLOCAGAO) {
        this.form.serie = 99;
      }
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    _mensagemErroSalvar(error) {
      const msg =
        error?.response?.data?.message ||
        error?.response?.data?.msg ||
        error?.message ||
        "";
      if (/padr[aã]o|única|unica|required|obrigat/i.test(msg)) {
        return "A empresa precisa ter uma configuração padrão para o PDV Web.";
      }
      return msg || "Não foi possível salvar a configuração.";
    },
    async onSubmit() {
      const submitButton = this.$refs["submit_nova_configuracao"];

      try {
        this.$v.form.$touch();

        if (this.$v.form.$anyError) {
          this.$toast.error(
            "Verifique todos os campos obrigatórios do formulário!"
          );
          return;
        }

        submitButton.classList.add("spinner", "spinner-light", "spinner-right");
        submitButton.setAttribute("disabled", "");

        await this.$http.post(this.url, this.form);

        if (this.form.modelo == 65 && this.form.padrao_pdv_web === true) {
          this.$toast.success("Configuração padrão do PDV Web atualizada com sucesso.");
        } else {
          this.$toast.success("Configuração salva com sucesso.");
        }

        if (this.onboardStore.currentStep > 0) {
          this.onboardStore.currentStep = 5;
        }

        this.$router.push({ name: "configuracoesLista" });
      } catch (error) {
        this.$toast.error(this._mensagemErroSalvar(error));
        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
        submitButton.removeAttribute("disabled", "");
      }
    },
  },
};
